import { isEqual } from 'lodash';
import { batch } from 'react-redux';
import { setIsError, setIsLoading } from '.';
import { addGroupToMessage, addRecipientsToMessage } from '../../../apis/chatAPI';
import { fetchTenant } from '../../Organizations/OrganizationsSlice/actionCreators';
import type { AppThunk } from '../../../store';
import { fetchCurrentChat } from '../../ChatsList/chatListSlice/actionCreators';
import type { SelectedGroup } from '../../CreateMessage/SelectGroupsList';
import { fetchAllGroupMembers } from '../../../api/groups';

export const addRecipients =
  (
    messageId: number,
    groups: SelectedGroup[],
    usersIds: number[],
    onFinish: () => void
  ): AppThunk =>
  async (dispatch, getState) => {
    try {
      dispatch(setIsLoading(true));

      let tenant = getState().organizations.tenant;
      if (!tenant) {
        await dispatch(fetchTenant());
        tenant = getState().organizations.tenant;
        if (!tenant) {
          throw new Error('Missing tenant');
        }
      }

      const currentRecipients = getState().chatList.messagesRecipients;
      const currentRecipientsIdsList = currentRecipients.map(rec => rec.userID);
      const groupMembersIDsList: number[] = [];

      const user = getState().user.user;
      const selectedUserIdsSet = new Set(usersIds);
      const isUserSelected = (userId: number) =>
        selectedUserIdsSet.size === 0 || selectedUserIdsSet.has(userId);

      for await (const group of groups) {
        const groupMembers = await fetchAllGroupMembers({ groupId: group.id, tenantId: tenant.id });

        // Only add members that are still selected in the Users tab;
        // if no selection was made, add all eligible members.
        const currentGroupMembersIds = groupMembers
          .filter(
            member =>
              !isEqual(user?.id, member.userID) &&
              !currentRecipientsIdsList.includes(member.userID) &&
              isUserSelected(member.userID)
          )
          .map(member => member.userID);

        groupMembersIDsList.push(...currentGroupMembersIds);
        await addGroupToMessage(messageId, group.id, currentGroupMembersIds);
      }
      const usersToAdd = (usersIds ?? []).filter(
        id => !groupMembersIDsList.includes(id) && !currentRecipientsIdsList.includes(id)
      );
      if (usersToAdd.length) {
        await addRecipientsToMessage(messageId, usersToAdd);
      }
      batch(() => {
        dispatch(fetchCurrentChat(`${messageId}`));
        dispatch(setIsLoading(false));
      });
      onFinish();
    } catch (error) {
      console.log('error log ', error);
      batch(() => {
        dispatch(setIsLoading(false));
        dispatch(setIsError(`${error}`));
      });
    }
  };
